import { useEffect, useState } from 'react'
import { getPlanLimits, type PlanLimitsResponse } from '@/api/public'

// サーバーの環境変数の既定値と同じ。ビルド時に静的生成するトップページと、API の応答が来るまではこれを表示する
export const DEFAULT_PLAN_LIMITS: PlanLimitsResponse = {
  free: { projects: 5, endpointsPerProject: 10, requestsPerMinute: 60, logRetentionDays: 30 },
  pro: { projects: null, endpointsPerProject: null, requestsPerMinute: 1000, logRetentionDays: 30 },
}

// 1回取れば十分なのでモジュール内に持つ。トップページの SSR(scripts/build-landing.mjs)には
// QueryClientProvider が無いため React Query は使わない(SSR では useEffect が走らず既定値になる)
let cached: PlanLimitsResponse | null = null
let inflight: Promise<PlanLimitsResponse> | null = null

export function usePlanLimits(): PlanLimitsResponse {
  const [limits, setLimits] = useState<PlanLimitsResponse>(cached ?? DEFAULT_PLAN_LIMITS)

  useEffect(() => {
    if (cached) return
    let active = true
    inflight ??= getPlanLimits().then((res) => (cached = res))
    inflight
      .then((res) => {
        if (active) setLimits(res)
      })
      .catch(() => {
        // 取れなければ既定値のまま。次にマウントしたときにもう一度試す
        inflight = null
      })
    return () => {
      active = false
    }
  }, [])

  return limits
}

// i18n の文言に埋め込む値(1,000 のように桁区切りする)
export function planLimitVars(limits: PlanLimitsResponse) {
  const fmt = (n: number) => n.toLocaleString('en-US')
  return {
    projects: fmt(limits.free.projects ?? 0),
    endpoints: fmt(limits.free.endpointsPerProject ?? 0),
    freeRpm: fmt(limits.free.requestsPerMinute),
    proRpm: fmt(limits.pro.requestsPerMinute),
    days: fmt(limits.free.logRetentionDays),
  }
}
